<template>
  <div class="h3">
    Vous nous avez communiqué les éléments suivants :
  </div>

  <div class="h4">
    Vous
  </div>

  <ul>
    <li>Date de naissance : {{ formatDateArrayInDDMMYYYY(user.dateDeNaissance) }}</li>
    <li>Régime obligatoire : {{ user.regime }}</li>
    <li>Activité : {{ user.activite }}</li>
    <li v-if="user.displayMadelin !== '0'">
      Loi Madelin : {{ user.madelinFormulaire === '2' ? 'Oui' : 'Non' }}
    </li>
  </ul>

  <div class="h4">
    Autres personnes à assurer :
  </div>

  <ul class="nobullet">
    <li>Nombre d'enfants : {{ user.nbEnfants }}</li>
    <li>Conjoint : {{ user.conjoint === '1' ? 'Oui' : 'Non' }}</li>
  </ul>

  <!-- Enfants -->
  <div v-if="user.nbEnfants > 0">
    <div class="h4">
      {{ user.nbEnfants > 1 ? `Vos ${user.nbEnfants} enfants` : 'Votre enfant' }}
    </div>
    <ul>
      <li
        v-for="enfant in user.enfants"
        :key="enfant.prenom"
      >
        {{ enfant.prenom }} {{ enfant.nom }} né(e) le {{ nxtcmsDateConverter(enfant.dateDeNaissance) }}
      </li>
    </ul>
  </div>

  <!-- Conjoint -->
  <div v-if="user.conjoint === '1'">
    <div class="h4">
      Votre conjoint :
    </div>
    <ul>
      <li>{{ user.libelleConjointe }}</li>
      <li>Date de naissance : {{ nxtcmsDateConverter(user.dateDeNaissanceConjoint) }}</li>
      <!-- Si conjoint non ayant droit -->
      <li v-if="user.ayantDroit === '2'">
        Régime obligatoire : {{ user.regimeConjoint }}
      </li>
      <li v-if="user.ayantDroit === '2' && user.displayMadelinConjoint">
        Loi Madelin obligatoire : {{ user.madelinFormulaireConjoint === 2 ? 'Non' : 'Oui' }}
      </li>
      <li v-if="user.ayantDroit === '2'">
        Activité : {{ user.activiteConjoint }}
      </li>
    </ul>
  </div>

  <!-- Coordonnées -->
  <div class="h4">
    Coordonnées :
  </div>

  <ul>
    <li>{{ user.adresse }}</li>
    <li>{{ user.codePostal }} {{ user.ville }}</li>
    <li>Email : {{ user.email }}</li>
    <li
      v-if="user.consent === '1'"
    >
      Téléphone : {{ user.telephone }}
    </li>
  </ul>
</template>

<script>

import {formatDateArrayInDDMMYYYY} from "@/modules/shared/utils/dateUtils";
import {nxtcmsDateConverter} from "src/modules/shared/utils/dateUtils";

export default {
  name: "RecapitulatifPersonalInformations",
  props: {
    user: {
      type:Object,
      required: true
    }
  },
  methods: {
    formatDateArrayInDDMMYYYY: (value) => formatDateArrayInDDMMYYYY(value),
    nxtcmsDateConverter: (value) => nxtcmsDateConverter(value)
  }
}
</script>

<style scoped>

</style>
